import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import comdetailsdata from '../data/comdetailsdata.json';
import { CusFormLabel } from '../validation/Form-Components';
import helper from '../factory/Helper';
 

const BizDtlsPreview = (props) => {
  const { response} = props

  return (
    <div>
    <Field component={CusFormLabel} 
      leftLabelId={'lblRegNo'} leftLabelName={comdetailsdata.label.RegNo}
      id={'RegNo'} name={response.Company_UEN !==null? response.Company_UEN:''} />
              
    <Field component={CusFormLabel} 
      leftLabelId={'lblCompName'} leftLabelName={comdetailsdata.label.CompName}
      id={'CompName'} name={response.Company_Name !==null? response.Company_Name:''} />

    <Field component={CusFormLabel} 
      leftLabelId={'lblCompType'} leftLabelName={comdetailsdata.label.CompType}
      id={'lblcompType'} name={response.Entity_Type_Desc !==null? response.Entity_Type_Desc:''} />

    <Field component={CusFormLabel} 
      leftLabelId={'lblDtOfInc'} leftLabelName={comdetailsdata.label.DtOfInc}
      id={'dtOfInc'} name={response.Registration_Date !==null? helper.formatDateDDMMYYYY(response.Registration_Date):''} />
  
    <Field component={CusFormLabel} 
      leftLabelId={'lblCountryOfInc'} leftLabelName={comdetailsdata.label.CountryOfInc}
      id={'countryOfInc'} name={response.Country_of_Incorporation_Desc !==null? response.Country_of_Incorporation_Desc:"SINGAPORE"} />

    <Field component={CusFormLabel} 
      leftLabelId={'lblDtOfInc'} leftLabelName={comdetailsdata.label.CompExpDate}
      id={'dtOfInc'} name={response.Business_Expiry_Date !==null? helper.formatDateDDMMYYYY(response.Business_Expiry_Date):''} />

    <Field component={CusFormLabel} 
      leftLabelId={'lblPrimaryBiz'} leftLabelName={comdetailsdata.label.primaryBiz} 
      id={'PrimaryBizAct'} name={response.Primary_Activity_Desc !==null? response.Primary_Activity_Desc:''} />

    <Field component={CusFormLabel} 
      leftLabelId={'lblSecdBiz'} leftLabelName={comdetailsdata.label.secondBiz}
      id={'SecondaryBizAct'} name={response.Secondary_Activity_Desc  !==null? response.Secondary_Activity_Desc:'' } /> 
    </div>
    
  )
}


export default BizDtlsPreview;